if (typeof CollectionTabsComponent !== 'function') {
	class CollectionTabsComponent extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				tabsListItem: '.collection-tabs__list-item',
				tabs: '.collection-tabs__tab',
			};

			this.classes = {
				active: 'active',
			};

			this.listItems = this.querySelectorAll(this.selectors.tabsListItem);
			this.tabs = this.querySelectorAll(this.selectors.tabs);
			this.currentListItem = this.listItems[0];
			this.currentTab = this.tabs[0];

			this.init();
		}

		init() {
			this.addEventListeners();
		}

		addEventListeners() {
			const { listItems } = this;

			listItems.forEach((item) => {
				item.addEventListener('click', (e) => {
					this.handleTabChange(e);
				});
			});
		}

		handleTabChange(e) {
			const { currentListItem } = this;

			const listItem = e.target;

			if (listItem == currentListItem) return;

			const refID = listItem.dataset.ref;
			const tab = this.querySelector(`#${refID}`);

			this.toggleTabs();
			this.setCurrentTab(listItem, tab);
		}

		setCurrentTab(listItem, tab) {
			const { classes } = this;

			this.currentListItem = listItem;
			this.currentTab = tab;

			this.currentListItem.classList.add(classes.active);
			this.currentTab.setAttribute('aria-hidden', 'false');
		}

		toggleTabs() {
			const { listItems, tabs, classes } = this;

			listItems.forEach((item) => {
				item.classList.remove(classes.active);
			});

			tabs.forEach((tab) => {
				tab.setAttribute('aria-hidden', 'true');
			});
		}
	}

	if (!customElements.get('collection-tabs')) {
		customElements.define('collection-tabs', CollectionTabsComponent);
	}
}
